export default "__VITE_ASSET__e93cb4ab__"